module.exports = __webpack_public_path__ + "static/img/4.9122b5b6.jpg";